export default __webpack_public_path__ + "static/media/tileovercutbefore.7883038f.jpg";